import React, { useState } from 'react';
import { IconButton, Tooltip, CircularProgress, Badge } from '@mui/material';
import { useHasPermission } from '../../permission/PermissionUtil';
import { useDataLoad } from '../../status/StatusContext';
import SendIcon from '@mui/icons-material/Send';
import DataLoadMenu from '../components/DataLoadMenu';
import DataLoadDialog from './DataLoadDialog';
import axios from 'axios';
import { toast } from 'react-toastify';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function DataSendButton() {

    const [loading, setLoading] = useState(false);
    const [isDataLoadVisible, setIsDataLoadVisible] = useState(false);
    const [isDataLoadMenuVisible, setIsDataLoadMenuVisible] = useState(false);

    const performDataSend = async () => {
        if (loading) return;
        setLoading(true);
        try {
            await axios.post('/dataload/send');
            toast.success('Updates Sent');
        } finally {
            setLoading(false);
        }
    };


    const onDataSendClick = (e) => {
        e.preventDefault();
        if (e.button === 0 && dataLoadCount > 0) {
            performDataSend();
        } else {
            setIsDataLoadMenuVisible(true)
        }
    };

    const hasSendDataPermission = useHasPermission("DataSend:SendData");
    const dataLoadCount = useDataLoad();

    if (!hasSendDataPermission) {
        return null;
    }

    return (
        <>
            <DataLoadMenu isVisible={isDataLoadMenuVisible} onHide={() => setIsDataLoadMenuVisible(false)} showDataLoadMenu={() => setIsDataLoadVisible(true)} />
            <DataLoadDialog visible={isDataLoadVisible} onClose={() => setIsDataLoadVisible(false)} />
            <IconButton
                size="large"
                type='button'
                onClick={onDataSendClick}
                onContextMenu={onDataSendClick}
                color="inherit"
                style={squareHighlightStyle}
            >
                <Badge badgeContent={dataLoadCount} color="error">
                    <Tooltip title={dataLoadCount > 0 ? 'Send Updates' : 'Data Send'}>
                        {loading ? <CircularProgress size={24} /> : <SendIcon />}
                    </Tooltip>
                </Badge>
            </IconButton>
        </>
    );
}
